import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import React from 'react';

import LandingPage from './pages/LandingPage';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import UnauthorizedPage from './pages/UnauthorizedPage';
import ErrorPage from './pages/ErrorPage';
import RegistrationPage from './pages/RegistrationPage';
import InvoiceTemplate from './components/InvoiceTemplate';
import PurchaseReceipt from './components/PurchaseReceipt';
import TenantRegistrationForm from './components/tenantcomponents/TenantRegistration/TenantRegistrationForm';


const getSubdomain = () => {
  const host = window.location.hostname;
  
  // localhost or Vercel preview domain → root
  if (host === 'localhost' || host.endsWith('.vercel.app')) {
    return null;
  }

  
  const parts = host.split('.');
  
  // Handle root domain and www subdomain
  if (parts.length <= 2 || parts[0] === 'www') {
    return null;
  }
  
  return parts[0];
};
const isLocalDevelopment = () => 
  process.env.NODE_ENV === 'development' && 
  window.location.hostname === 'localhost';

// ── Outside App function ────────────────────────────────────── added on 4Th june, 26
if (isLocalDevelopment()) {
  const params = new URLSearchParams(window.location.search);
  if (params.get('tenant') === 'local') {
    sessionStorage.setItem('tenantEnabled', 'true');
  }
}


function App() {
  
   // 1. First call hooks unconditionally
  const subdomain = getSubdomain();

  // No useState/useEffect — computed synchronously every render
  const enableTenantRoutes = isLocalDevelopment() && sessionStorage.getItem('tenantEnabled') === 'true';


  // 2. Then check for admin paths
  const isAdminPath = () => /^\/(?:[^/]+\/)?admin(?:\/|$)/.test(window.location.pathname);

  if (isAdminPath()) {
    console.log('🔒 Bypassing React for admin path:', window.location.pathname);
    return null;
  }

  // 3. Then proceed with normal rendering
  //console.log('🔍 DEBUG → hostname:', window.location.hostname);
  //console.log('🔍 DEBUG → subdomain:', subdomain);
  //console.log('🔍 DEBUG → tenant routes enabled:', enableTenantRoutes);

  // FIXED: Inverted the condition here
  if (!subdomain && !enableTenantRoutes) {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/register-tenant" element={<TenantRegistrationForm />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    );
  }

  // Tenant routes should render when subdomain exists OR override is enabled
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegistrationPage />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<PrivateRoute allowedRoles={['system_admin', 'system_manager', 'system_user']} />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/invoice/sale/:id" element={<InvoiceTemplate />} />
          <Route path="/receipt/purchase/:id" element={<PurchaseReceipt />} />
        </Route>

        {/* System Routes */}
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="*" element={<ErrorPage code={404} />} />
      </Routes>
    </Router>
  );
}

export default App;
